import React from "react";
import { classNames } from "./utils/classNames";
export const Placeholder = ({ width = "100%", className, }) => {
    return (React.createElement("span", { className: classNames("placeholder animated", className), style: { width } }));
};
